import { IReportContact } from 'dashboard409a/services/types';
import { TERMINAL_EXTRACTION_STATUSES } from './ProcessReportModal.constants';

// Best-effort recovery of the Valuation-relative date folder (Company/Date/) from a
// stored file key like `Valuation/Company/Date/Report/file.pdf` so the picker can
// reopen at the remembered folder.
export const deriveDatePrefix = (key: string | null): string => {
  if (!key) {
    return '';
  }
  const relative = key.startsWith('Valuation/') ? key.slice('Valuation/'.length) : key;
  const parts = relative.split('/').filter(Boolean);
  if (parts.length >= 3) {
    return `${parts.slice(0, parts.length - 2).join('/')}/`;
  }
  return '';
};

export const isTerminalExtractionStatus = (status: string | null | undefined): boolean =>
  Boolean(status) && TERMINAL_EXTRACTION_STATUSES.includes((status as string).toLowerCase());

export const toggleExclusivePath = (prev: string | null, path: string): string | null =>
  prev === path ? null : path;

export const contactSelectKey = (contact: IReportContact, index: number): string =>
  contact.recordId || contact.email || `contact-${index}-${contact.name ?? ''}`;

export const formatCombinedEmail = (subject: string, body: string): string => {
  const trimmedSubject = subject.trim();
  const trimmedBody = body.trim();
  if (trimmedSubject && trimmedBody) {
    return `Subject: ${trimmedSubject}\n\n${trimmedBody}`;
  }
  return trimmedSubject ? `Subject: ${trimmedSubject}` : trimmedBody;
};

export const fileNameFromPath = (path: string | null): string =>
  path ? (path.split('/').filter(Boolean).at(-1) ?? '') : '';
